/**
 * Sanitizes a string for safe display in user-facing messages
 * Prevents XSS by escaping potentially dangerous characters
 */
export const sanitizeForDisplay = (input: string | undefined | null): string => {
  if (!input) return 'Unknown';
  
  return input
    .replace(/"/g, '\\"')
    .replace(/'/g, "\\'")
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/&/g, '&amp;');
};

/**
 * Validates that required IDs exist before API operations
 */
export const validateRequiredIds = (...ids: (string | null | undefined)[]): boolean => {
  return ids.every(id => id != null && id.trim() !== '');
};
